export interface TaskResponse {
  patientId: string;
  patientFullName: string;
  patientMrn: string;
  patientFhirUUID: string;
  fhirId: string;
  taskUUID: string;
  ownerType: string;
  ownerFhirId: string;
  ownerName: string;
  ownerEmail: string;
  ownerPhone: string;
  status: string;
  taskType: string;
  createdAt: string;
  patientBirthDate: string;
  requesterFhirId: string;
  requesterName: string;
  requesterEmail: string;
  periodEnd: string;
  periodStart: string;
  taskCodeCodingDisplay: string;
  taskDescription: string;
  internalNumber: string;
}

export interface PaginatedTaskResponse {
  data: TaskResponse[];
  stats: any;
  links: {
    current: string;
  };
  meta: {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
}

export enum TaskStatusValue {
  Draft = 'draft',
  Requested = 'requested',
  Received = 'received',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Ready = 'ready',
  Cancelled = 'cancelled',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  Failed = 'failed',
  Completed = 'completed',
  EnteredInError = 'entered-in-error',
}
